import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { learnCards } from "@/mocks/home";

export default function LearnSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-content px-5 py-16 md:px-6 md:py-20">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-600">
            What you can learn
          </p>
          <h2 className="mt-3 font-heading text-[26px] font-bold tracking-tight text-foreground-950 md:text-[34px]">
            このサイトでわかること
          </h2>
          <p className="mt-4 text-[13px] leading-[1.95] text-foreground-600 md:text-[14px]">
            基本の情報はすべて無料で読めます。テキサス州のコミカレ留学から編入準備まで、テーマごとにまとめています。各記事には内容の概要も載せているので、スクロールしながら読みたい記事を探せます。
          </p>
        </Reveal>

        <div className="mt-11 grid gap-5 sm:grid-cols-2 md:gap-6 lg:grid-cols-3">
          {learnCards.map((card, index) => (
            <Reveal key={card.id} delay={(index % 3) * 70} className="h-full">
              <Link
                to={card.to}
                className="group flex h-full flex-col rounded-[10px] border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-[3px] hover:border-primary-300 hover:shadow-[0_20px_36px_-26px_rgba(23,37,35,0.45)] md:p-7"
              >
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className="inline-flex max-w-full items-center gap-1.5 rounded-full bg-primary-50 px-2.5 py-1 text-[10.5px] font-semibold text-primary-800">
                    <i className={`${card.icon} shrink-0 text-[12px]`} />
                    <span className="truncate">{card.category}</span>
                  </span>
                  <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-background-100 px-2.5 py-1 text-[10.5px] font-semibold text-foreground-600">
                    <i className="ri-check-line text-[11px] text-primary-600" />
                    {card.badge}
                  </span>
                </div>

                <h3 className="mt-4 font-heading text-[17px] font-bold leading-[1.6] text-foreground-950 md:text-[18px]">
                  {card.title}
                </h3>
                <p className="mt-2.5 flex-1 text-[12.5px] leading-[1.95] text-foreground-600 md:text-[13px]">
                  {card.description}
                </p>

                <span className="mt-5 inline-flex w-fit items-center gap-1.5 rounded-full border border-primary-300 bg-background-50 px-4 py-1.5 text-[12px] font-semibold text-primary-700 transition-colors duration-200 group-hover:border-primary-400 group-hover:bg-primary-50">
                  詳しく読む
                  <i className="ri-arrow-right-line text-[13px] transition-transform duration-300 group-hover:translate-x-0.5" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-6">
          <div className="flex flex-col gap-5 rounded-[12px] border border-dashed border-background-300 bg-background-100 p-6 md:flex-row md:items-center md:justify-between md:p-7">
            <div className="flex items-start gap-4">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-background-50 text-foreground-600">
                <i className="ri-lock-line text-[20px]" />
              </span>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <p className="font-heading text-[15px] font-bold text-foreground-950">
                    有料PDFガイド
                  </p>
                  <span className="inline-flex items-center gap-1 rounded-full bg-background-50 px-2.5 py-1 text-[10.5px] font-semibold text-foreground-600">
                    <i className="ri-time-line text-[11px]" />
                    準備中
                  </span>
                </div>
                <p className="mt-2 max-w-2xl text-[12.5px] leading-[1.95] text-foreground-600">
                  ビザ申請・TSIA2対策・留学準備の実践資料をPDFガイドとして準備しています。現在は制作中のため購入できません。
                </p>
              </div>
            </div>
            <Link
              to="/guides"
              className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-5 py-2.5 text-[12.5px] font-semibold text-foreground-700 transition-all duration-200 hover:-translate-y-[2px] hover:border-primary-300 hover:text-primary-800"
            >
              ガイドを見る
              <i className="ri-arrow-right-line text-[14px]" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}